<template>
  <div id="app">
    <CookieNotice />
    <Header />
    <router-view />
  </div>
</template>

<script>
import CookieNotice from '@/components/CookieNotice/index.vue';
import Header from '@/components/Header/index.vue';

export default {
  components: {
    CookieNotice,
    Header,
  },
};
</script>

<style lang="scss" src="./styles/index.scss"></style>
